export class AirportLookupModel {
  public airportCode: string;
  public city: string;
  public region: string;
  public countryCode: string;
  public fullName: string;
  public airportName: string;
  public cityCode: string;
  public aliases: string[];
  public restrictMPM: string;
  public restrictMiles: string;
  public restrictFlightHotel: string;
  public restrictCash: string;
  public flightHotelDest: string;
  public restrictNonJvPartner: string;

  constructor(
    airportCode: string,
    airportCity: string,
    airportRegion: string,
    airportCountry: string,
    airportFullName: string,
    airportName = '',
    cityCode = '',
    aliases = [],
    attributes = []
  ) {
    this.airportCode = airportCode;
    this.city = airportCity;
    this.region = airportRegion;
    this.countryCode = airportCountry;
    this.fullName = airportFullName;
    this.airportName = airportName;
    this.cityCode = cityCode;
    this.aliases = aliases;
    if (attributes != null) {
      this.restrictMPM = attributes[4];
      this.restrictMiles = attributes[5];
      this.restrictCash = attributes[6];
      if (attributes.length >= 8) {
        this.restrictFlightHotel = attributes[7];
      }
      if (attributes.length >= 9) {
        this.flightHotelDest = attributes[8];
      }
      if (attributes.length >= 10) {
        this.restrictNonJvPartner = attributes[9];
      }
    }
  }
}

export class DefaultProvincesLookupModel {
  public countryCode: string;
  public stateProvinceCode: string;
  public stateProvinceName: string;

  constructor(
    countryCode: string,
    stateProvinceCode: string,
    stateProvinceName: string
  ) {
    this.countryCode = countryCode;
    this.stateProvinceCode = stateProvinceCode;
    this.stateProvinceName = stateProvinceName.toLowerCase();
  }
}

export class CountryListLookupModel {
  public countryCode: string;
  public countryName: string;

  constructor(countryCode: string, countryName: string) {
    this.countryCode = countryCode;
    this.countryName = countryName;
  }
}

export class AirportListLookupModel {
  public airportCode: string;
  public airportName: string;
  public awardTktTypCd: string;
  public cityCode: string;
  public cityName: string;
  public cityServe: string;
  public cityType: string;
  public codeShareOnlyInd: string;
  public countryCode: string;
  public eurpnUnionCityInd: string;
  public nonStdFreqOfOperationInd: string;
  public nonStdFreqOfOperationText: string;
  public region: string;
  public timeZone: string;
  public useTimeForAvailability: string;

  constructor(
    airportCode: string,
    airportName: string,
    awardTktTypCd: string,
    cityCode: string,
    cityName: string,
    cityServe: string,
    cityType: string,
    codeShareOnlyInd: string,
    countryCode: string,
    eurpnUnionCityInd: string,
    nonStdFreqOfOperationInd: string,
    nonStdFreqOfOperationText: string,
    region: string,
    timeZone: string,
    useTimeForAvailability: string
  ) {
    this.airportCode = airportCode;
    this.airportName = airportName.toLowerCase();
    this.awardTktTypCd = awardTktTypCd;
    this.cityCode = cityCode;
    this.cityName = cityName;
    this.cityServe = cityServe;
    this.cityType = cityType;
    this.codeShareOnlyInd = codeShareOnlyInd;
    this.countryCode = countryCode;
    this.eurpnUnionCityInd = eurpnUnionCityInd;
    this.nonStdFreqOfOperationInd = nonStdFreqOfOperationInd;
    this.nonStdFreqOfOperationText = nonStdFreqOfOperationText;
    this.region = region;
    this.timeZone = timeZone;
    this.useTimeForAvailability = useTimeForAvailability;
  }
}
